import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('solitaire');

const SolitairePage = () => <CaseStudyPage project={project} />;

export default SolitairePage;
